import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggle"]

  connect() {
    this.checkIfTruncated()
  }

  checkIfTruncated() {
    // Check if content is truncated (scrollHeight > clientHeight)
    if (this.contentTarget.scrollHeight > this.contentTarget.clientHeight) {
      this.toggleTarget.classList.remove('d-none')
      this.truncateContent()
    }
  }

  truncateContent() {
    this.contentTarget.style.maxHeight = `60px`
    this.contentTarget.style.overflow = 'hidden'
    this.contentTarget.style.display = '-webkit-box'
    this.contentTarget.style.webkitLineClamp = '2'
    this.contentTarget.style.webkitBoxOrient = 'vertical'
  }

  toggle() {
    const seeMoreText = this.toggleTarget.querySelector('.see-more-text')
    const seeLessText = this.toggleTarget.querySelector('.see-less-text')

    if (this.contentTarget.style.maxHeight && this.contentTarget.style.maxHeight !== 'none') {
      // Expand
      this.contentTarget.style.maxHeight = 'none'
      this.contentTarget.style.webkitLineClamp = 'unset'
      seeMoreText.classList.add('d-none')
      seeLessText.classList.remove('d-none')
    } else {
      // Collapse
      this.truncateContent()
      seeMoreText.classList.remove('d-none')
      seeLessText.classList.add('d-none')
    }
  }
} 